import styled from 'styled-components';
import style from './style';

const FlexContainer = styled.div`
  ${style}
`;

export default FlexContainer;
